import {
  CSW_PRODUCT_CLICK,
  HOME_SERVICE_LINK_CLICK,
  HOME_SWAP_CSW_AND_SERVICES,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export default async () => {
  const MULTILINE_CSW_SELECTOR = '.o-SliderHorizontal__wrapper--noSlider'

  const { isEnabled } = getExperimentOnClient(HOME_SWAP_CSW_AND_SERVICES) || {}

  if (isEnabled) {
    await activateExperiment(HOME_SWAP_CSW_AND_SERVICES)
    document.body.addEventListener('click', (e: MouseEvent) => {
      const target = <HTMLElement>e.target

      if (
        target.closest(
          `${MULTILINE_CSW_SELECTOR} [data-clientside-hook="slider__item"]`
        )
      ) {
        trackOptimizelyEvent(CSW_PRODUCT_CLICK)
      }
      if (target.closest('.o-IconLinksList__item')) {
        trackOptimizelyEvent(HOME_SERVICE_LINK_CLICK)
      }
    })
  }
}
